import React from 'react'

const  Home = () => {
  return (
    <div>
      Hii
    </div>
  )
}

export default  Home
